<template>
  <div class="activitiesManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">跨界活动管理</span>
              <div class="pull-right">
                <el-button @click="handleAdd" type="warning">新增</el-button>
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-wrap">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">活动时间：</span>
                  <!-- <div class="time-box flex-al">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.ad')"
                      v-model="selectForms.activity_startdate"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Crmactivemanage.ae")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.af')"
                      v-model="selectForms.activity_enddate"
                      style="width: 140px"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div> -->
                  <div class="time-box flex-al">
                    <el-date-picker
                      style="width: 250px;"
                      @change="handleSelect"
                      v-model="selectForms.rangeTime"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      clearable
                      filterable
                      placeholder="请选择渠道类型"
                      v-model="selectForms.frommedia_name"
                      @change="handlefrommediaSearch"
                      @clear="selectSearch"
                    >
                      <el-option
                        v-for="item in SourceList"
                        :key="item.frommedia_id"
                        :value="item.frommedia_name"
                        :label="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      clearable
                      filterable
                      placeholder="请选择渠道明细"
                      v-model="selectForms.channel_id"
                      @change="selectSearch"
                      @clear="selectSearch"
                    >
                      <el-option
                        v-for="item in ChannelList"
                        :key="item.channel_id"
                        :value="item.channel_id"
                        :label="item.channel_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb10 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      v-model="selectForms.activity_amounttype"
                      clearable
                      filterable
                      placeholder="请选择中奖类型"
                      @change="selectSearch"
                      @clear="selectSearch"
                    >
                      <el-option
                        v-for="(item, index) in selectForms.amounttypeOptions"
                        :key="index"
                        :label="item.activity_amounttypename"
                        :value="item.activity_amounttype"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      v-model="selectForms.activity_is_amount"
                      clearable
                      filterable
                      placeholder="是否有活动预算"
                      @change="selectSearch"
                      @clear="selectSearch"
                    >
                      <el-option
                        v-for="(item, index) in selectForms.is_amountOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      placeholder="可检索活动名称、联系人手机号"
                      class="input-cont"
                      style="width: 220px"
                      v-model="selectForms.keyword"
                      @change="selectSearch"
                      @clear="selectSearch"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Crmactivemanage.as") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <reserveImgTableCont
                  :tableData="tableDatas"
                  @handleColumnChange="handleColumnChange"
                  @handleCodeChange="handleCodeChange"
                >
                  <el-table-column
                    label="操作"
                    align="center"
                    width="320px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <!-- 已结束2 未开始0  已开始 1  -->
                      <el-button
                        v-if="
                          scope.row.activity_status == 2 ||
                            scope.row.activity_status == 1
                        "
                        type="text"
                        @click="handleListInfo(scope.row)"
                        >名单信息</el-button
                      >
                      <el-button
                        v-if="scope.row.activity_status == 1"
                        type="text"
                        @click="handleEndActivity(scope.row)"
                        >结束活动</el-button
                      >
                      <el-button
                        v-if="scope.row.activity_status == 0"
                        type="text"
                        @click="handleEdit(scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        v-if="scope.row.activity_status == 0"
                        type="text"
                        @click="handleDelete(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </reserveImgTableCont>
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 二维码 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="tan-code clearFloat"
      width="500px"
      :before-close="handleCloseCode"
    >
      <div
        class="pull-right h1 btn-close font-333"
        style="cursor: pointer"
        @click="handleCloseCode"
      >
        <i class="el-icon-close"></i>
      </div>
      <div class="code">
        <!-- <img :src="onCodeInfo.oneCodeImg" alt /> -->

        <!-- <div class="code-img"> -->
        <iframe
          frameborder="0"
          :src="onCodeInfo.oneCodeWxImg"
          width="380"
          height="400"
        ></iframe>
        <!-- </div> -->

        <!-- <div class="code-img">
          <div class="left">
            <p v-if="languageType == 'zh'">{{ $t("Crmactivemanage.at") }}</p>
            <div
              class="one-img"
              :class="{ 'one-tw-img': languageType != 'zh' }"
            >
              <img :src="onCodeInfo.oneCodeImg" alt />
            </div>
          </div>
          <div v-if="languageType == 'zh'" class="right">
            <p>{{ $t("Crmactivemanage.au") }}</p>
            <iframe
              frameborder="0"
              :src="onCodeInfo.oneCodeWxImg"
              width="220"
              height="220"
            ></iframe>
          </div>
        </div>

        <p class="h1">{{ $t("Crmactivemanage.av") }}</p> -->
      </div>
      <!-- <p style="text-align: center">
        {{ $t("Crmactivemanage.aw") }}{{ onCodeInfo.oneCodeUrl }}
      </p> -->
    </el-dialog>

    <!-- 侧边新建栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxCreate"
      @hideSliderBox="hideSliderBoxCreate"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain slider-activitiesManage">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ dialogTitles == "add" ? "新增" : "编辑" }}跨界活动
          </p>
          <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
            <i class="el-icon-close"></i>
          </div>
          <el-button
            type="primary"
            class="pull-right"
            @click="onSubmit('ruleFrom')"
            >提交</el-button
          >
          <!-- <el-button type="primary" v-else class="pull-right" @click="onSubmit">{{
            $t("active.confirmEdit")
          }}</el-button> -->
        </div>
        <div class="slider-cont text-1">
          <el-form
            ref="ruleFrom"
            :model="crossOverForm"
            :rules="crossOverFormRules"
            label-width="140px"
          >
            <el-form-item label="活动名称：" prop="activity_name">
              <el-input
                :maxlength="15"
                v-model="crossOverForm.activity_name"
                style="width: 412px"
                placeholder="请输入活动名称"
              ></el-input>
              <span class="tip-text">
                <i class="tip-icon">!</i>
                {{ $t("active.nameOnly") }}
              </span>
            </el-form-item>
            <el-form-item label="渠道类型：" prop="frommedia_name">
              <el-select
                v-model="crossOverForm.frommedia_name"
                @change="frommediaSearch"
                placeholder="请输入渠道类型"
                style="width: 412px"
              >
                <el-option
                  v-for="item in SourceList"
                  :key="item.frommedia_id"
                  :label="item.frommedia_name"
                  :value="item.frommedia_name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道明细：" prop="channel_id">
              <el-select
                v-model="crossOverForm.channel_id"
                placeholder="请输入渠道明细"
                style="width: 412px"
              >
                <el-option
                  v-for="item in ChannelList"
                  :key="item.channel_id"
                  :label="item.channel_name"
                  :value="item.channel_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人：" prop="activity_contract">
              <el-input
                :maxlength="10"
                v-model="crossOverForm.activity_contract"
                placeholder="请输入联系人姓名"
                style="width: 412px"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="business_mobile">
              <el-input
                v-model="crossOverForm.business_mobile"
                placeholder="请输入联系人手机号"
                style="width: 412px"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否有活动预算：" prop="activity_is_amount">
              <el-radio-group
                v-model="crossOverForm.activity_is_amount"
                @change="handChange"
              >
                <el-radio
                  v-for="item in crossOverForm.activity_is_amountOptions"
                  :key="item.activity_is_amount"
                  :label="item.activity_is_amount"
                  >{{ item.activity_is_amountname }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="活动预算："
              prop="activity_amount"
              v-if="changeVal == 1 ? !isShowInput : isShowInput"
            >
              <!-- <el-input
                v-model="crossOverForm.activity_amount"
                :maxlength="10"
                :onkeyup="crossOverForm.activity_amount=crossOverForm.activity_amount.replace(/[^\d.]/g,'')"
                placeholder="请输入活动预算金额"
                style="width: 412px"
              ></el-input> -->
              <el-input
                v-model="crossOverForm.activity_amount"
                @input="checkInput(crossOverForm.activity_amount)"
                placeholder="请输入活动预算金额"
                style="width: 412px"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动时间：" prop="activity_startdate">
              <el-date-picker
                v-model="crossOverForm.activity_startdate"
                style="width: 412px"
                type="daterange"
                range-separator=""
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="timesChange"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="中奖类型：" prop="activity_amounttype">
              <el-radio-group
                v-model="crossOverForm.activity_amounttype"
                @change="handleChange"
              >
                <el-radio
                  v-for="(item, index) in crossOverForm.winningTypeOptions"
                  :key="index"
                  :label="item.activity_amounttype"
                  >{{ item.activity_amounttypename }}</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="中奖金额："
              prop="winningAmounts"
              v-if="changeVal2 == 1"
            >
              <!-- <el-input
                  :maxlength="5"
                  v-model="crossOverForm.winningAmounts.winningAmount1"
                  :onkeyup="crossOverForm.winningAmounts.winningAmount1=crossOverForm.winningAmounts.winningAmount1.replace(/[^\d.]/g,'')"
                  style="width: 190px"
                ></el-input>
                <span style="margin: 0 13px">-</span>
                <el-input
                  :maxlength="5"
                  :onkeyup="crossOverForm.winningAmounts.winningAmount2=crossOverForm.winningAmounts.winningAmount2.replace(/[^\d.]/g,'')"
                  v-model="crossOverForm.winningAmounts.winningAmount2"
                  style="width: 190px"
                ></el-input> -->
              <el-input
                v-model="crossOverForm.winningAmounts.winningAmount1"
                @input="
                  checkInput2(crossOverForm.winningAmounts.winningAmount1)
                "
                style="width: 190px"
              ></el-input>
              <span style="margin: 0 13px">-</span>
              <el-input
                @input="
                  checkInput3(crossOverForm.winningAmounts.winningAmount2)
                "
                v-model="crossOverForm.winningAmounts.winningAmount2"
                style="width: 190px"
              ></el-input>
            </el-form-item>

            <el-form-item label="中奖金额：" prop="winningAmount" v-else>
              <!-- <el-input
                  :maxlength="5"
                  :onkeyup="crossOverForm.winningAmount=crossOverForm.winningAmount.replace(/[^\d.]/g,'')"
                  v-model="crossOverForm.winningAmount"
                  placeholder="请输入中奖金额"
                  style="width: 412px"
                ></el-input> -->
              <el-input
                @input="checkInput4(crossOverForm.winningAmount)"
                v-model="crossOverForm.winningAmount"
                placeholder="请输入中奖金额"
                style="width: 412px"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动规则：" prop="activity_rule">
              <VueNeditorWrap
                ref="ueditor"
                v-model="crossOverForm.activity_rule"
                :destroy="false"
                :config="config"
                style="width: 412px"
              ></VueNeditorWrap>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- <activeTeamp
        :aciveInfo="aciveCreateInfo"
        :showSliderBox="showSliderBoxCreate"
        @hideSliderBox="hideSliderBoxCreate"
        @onSubmit="onSubmit"
        @perviewTemp="perviewTemp"
        @perviewSeeTemp="perviewSeeTemp"
      ></activeTeamp> -->
    </SliderBox>

    <el-dialog
      title="是否提前结束活动"
      :visible.sync="dialogVisibleEnd"
      width="30%"
    >
      <div class="dialog-body" style="line-height: 22px">
        确认提前结束<span style="color: #20a8d8">{{ activity_name }}活动</span
        >,提前结束活动名单将不会再进入CRM系统中（系统自动发送短信提醒商家<span
          >{{ activity_name }}</span
        >活动已提前结束）
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEnd = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="是否删除活动"
      :visible.sync="dialogVisibleDel"
      width="30%"
    >
      <div class="del-box">
        <div class="delete-tips tc">
          <span
            >是否确认删除<span style="color: #20a8d8">{{ activity_name }}</span
            >？</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDel = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmDel">确 定</el-button>
      </span>
    </el-dialog>

    <div class="customModel" v-if="customModelVisible"></div>
    <div class="customFather" v-if="customModelVisible2">
      <div class="customChild">
        <span class="customInfo"
          >您已经成功结束<span style="color: #20a8d8"
            >{{ activity_name }}活动</span
          >，短信通知已发送</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import SliderBox from "../../components/SliderBox";
import reserveImgTableCont from "../../components/tables/reserveImgTableCont.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
import VueNeditorWrap from "vue-neditor-wrap";
export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("active.rule_tips1")));
      } else {
        const reg = /^(1[3-9]\d{9})$|^([69]\d{7})$|^([6]\d{5})$|^(09\d{8})$/;
        (() => {})(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t("active.rule_tips2")));
        }
      }
    };
    return {
      isShowInput: false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      config: {
        UEDITOR_HOME_URL: "/NEditor/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        wordCount: false,
        elementPathEnabled: false,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: this.$uploadAction('/Uploading/Picture'),
        toolbars: [
          [
            // "insertimage",
            // "insertvideo",
            // 'insertcode',
            "source",
            "justifyleft",
            "justifyright",
            "justifycenter",
            "justifyjustify",
            "fontfamily",
            "fontsize",
            "forecolor",
            "backcolor",
          ],
        ],
      },
      customModelVisible: false,
      customModelVisible2: false,
      isShow: true,
      isShow2: false,
      changeVal: "",
      changeVal2: "",
      dialogTitles: "",
      activity_id: "", // 活动id
      activity_name: "",
      frommedia_id: "",
      channel_id: "",
      activity_contract: "",
      business_mobile: "",
      activity_amount: "",
      activity_amounttype: "",
      activity_startdate: "",
      activity_enddate: "",
      activity_amountrange: "",

      school_id: "",
      selectForms: {
        rangeTime: "",
        frommedia_name: "",
        // frommedia_id: '',
        channel_id: "",
        activity_startdate: "",
        activity_enddate: "",
        activity_amounttype: "",
        activity_is_amount: "",
        keyword: "",
        amounttypeOptions: [
          { activity_amounttype: "0", activity_amounttypename: "固定金额" },
          { activity_amounttype: "1", activity_amounttypename: "随机金额" },
        ],
        is_amountOptions: [
          { value: 0, label: "否" },
          { value: 1, label: "是" },
        ],
      },
      dialogVisibleEnd: false,
      dialogVisibleDel: false,
      crossOverForm: {
        activity_name: "", // 活动名称
        frommedia_name: "", // 渠道类型
        // frommedia_id: '',   // 渠道类型
        channel_id: "", // 渠道明细
        activity_contract: "", // 联系人
        business_mobile: "", // 手机号
        activity_is_amount: "", // 是否有活动预算 	是否有预算 0无 1有
        activity_is_amountOptions: [
          { activity_is_amount: "1", activity_is_amountname: "是" },
          { activity_is_amount: "0", activity_is_amountname: "否" },
        ],

        activity_amount: "", // 活动预算金额
        activity_startdate: "", // 活动时间
        // activity_enddate: '',
        activity_amounttype: "", // 中奖金额类型 0:固定金额 1:随机金额
        winningTypeOptions: [
          { activity_amounttype: "0", activity_amounttypename: "固定金额" },
          { activity_amounttype: "1", activity_amounttypename: "随机金额" },
        ],
        winningAmount: "", // 中奖金额
        winningAmounts: {
          winningAmount1: "",
          winningAmount2: "",
        },
        activity_rule: "", // 活动规则
      },
      crossOverFormRules: {
        activity_name: [
          { required: true, message: "请输入活动名称", trigger: "change" },
        ],
        frommedia_name: [
          { required: true, message: "请输入渠道类型", trigger: "change" },
        ],
        // frommedia_id: [
        //   { required: true, message: '请输入渠道类型', trigger: 'change' },
        // ],
        channel_id: [
          { required: true, message: "请输入渠道明细", trigger: "change" },
        ],
        activity_contract: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        business_mobile: [
          // { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        activity_is_amount: [
          {
            required: true,
            message: "请选择是否有活动预算",
            trigger: "change",
          },
        ],
        activity_amount: [
          { required: true, message: "请输入活动预算金额", trigger: "blur" },
        ],
        activity_startdate: [
          {
            required: true,
            message: "请选择开始时间和结束时间",
            trigger: "change",
          },
        ],
        activity_amounttype: [
          { required: true, message: "请选择中奖类型", trigger: "change" },
        ],
        winningAmount: [
          { required: true, message: "请输入中奖金额", trigger: "blur" },
        ],
        // winningAmounts: [
        //   { required: true, message: '请输入中奖金额', trigger: 'blur' },
        // ],

        activity_rule: [
          { required: true, message: "请输入活动规则", trigger: "blur" },
        ],
      },

      openMenu: ["1"],
      showSliderBoxCreate: false,
      showSliderBoxEdit: false,
      showSliderBoxSee: false,
      currentPage: 1,
      dialogVisible: false,
      PreviewVisible: false, //活动模板预览图
      DelVisible: false, //删除
      copyItem: false, //复制
      fullscreenLoading: true, //全屏loading
      goalId: "",
      onCodeInfo: {
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },

      ActivitytempOne: {}, //单个模板信息
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      creatimageUrl: "",
      imageUrl: "",
      dialogimgVisible: false,
      input: "",
      select: "",
      sliderWidth: "800px",
      sliderSeeWidth: "450px",
      activeName: "first",
      activeName1: "first",
      activityId: "", //暂存查看的活动id
      activeOne: {}, //单个活动信息
      infoForm: {
        a_content: "",
        editorOption: {},
      },
      //富文本编辑器
      // defaultMsg: this.$t("Crmactivemanage.bd"),
      // config: {
      //   initialFrameWidth: null,
      //   initialFrameHeight: 350,
      // },
      //筛选条件
      // selectForm: {
      // goal_starttime: "",
      // goal_endtime: "",
      // found_marketer_id: "",
      // activity_pattern: "", //活动类型
      // channel_id: "", //渠道明细
      // frommedia_name: "", //渠道类型
      // keyword: "",
      // },
      //创建人
      // founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      // 发布活动
      aciveCreateInfo: {
        aciveText: this.$t("Crmactivemanage.be"),
        aciveClass: "silder-contain-creat",
      },
      // 编辑活动
      // aciveEditInfo: {
      //   aciveText: this.$t("Crmactivemanage.bf"),
      //   aciveClass: "silder-contain-edit",
      // },
      tableDatas: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    reserveImgTableCont,
    VueNeditorWrap,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    console.warn(this.$store.state.SCHOOL_ID);
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    this.getSourceTwoApi(); // 获取渠道类型
    this.getChannelTwoApi(); // 获取渠道明细
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(310); //设置表格高度
    this.activityList();
  },
  computed: {
    // editor() {
    //   return this.$refs.myQuillEditor.quill;
    // },
  },
  methods: {
    checkInput(val) {
      this.crossOverForm.activity_amount = this.dealInputValTen(val);
      //  this.crossOverForm.activity_amount = this.dealInputVal(this.crossOverForm.activity_amount);
    },
    // 控制输入框十位整数位两位小数位，其他字符不让输入
    dealInputValTen(value) {
      value = value.replace(/^0*(0\.|[1-9])/, "$1");
      value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      value = value.replace(/\.{1,}/g, "."); //只保留第一个.清除多余的
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      value = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      value =
        value.indexOf(".") > 0
          ? value.split(".")[0].substring(0, 10) + "." + value.split(".")[1]
          : value.substring(0, 10);
      return value;
    },

    checkInput2(val) {
      this.crossOverForm.winningAmounts.winningAmount1 = this.dealInputValFive(
        val
      );
    },
    checkInput3(val) {
      this.crossOverForm.winningAmounts.winningAmount2 = this.dealInputValFive(
        val
      );
    },
    checkInput4(val) {
      this.crossOverForm.winningAmount = this.dealInputValFive(val);
    },
    // 控制输入框五位整数位两位小数位，其他字符不让输入
    dealInputValFive(value) {
      value = value.replace(/^0*(0\.|[1-9])/, "$1");
      value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      value = value.replace(/\.{1,}/g, "."); //只保留第一个.清除多余的
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      value = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      value =
        value.indexOf(".") > 0
          ? value.split(".")[0].substring(0, 10) + "." + value.split(".")[1]
          : value.substring(0, 5);
      return value;
    },

    handlefrommediaSearch() {
      this.selectForms.channel_id = "";
      this.tableDatas.list = [];
      this.getChannelTwoApi();
      this.activityList();
    },
    frommediaSearch() {
      this.crossOverForm.channel_id = "";
      this.getChannelTwoApi();
    },
    // loadUeditor(p) {
    //   (() => {})(p);
    // },
    selectSearch() {
      this.tableDatas.list = [];
      this.activityList();
    },
    handChange(val) {
      
      this.changeVal = val;
      // this.changeVal == 0 ? this.crossOverForm.activity_amount = '0' : this.crossOverForm.activity_amount;
    },
    handleChange(val) {
      
      this.changeVal2 = val;
      if (val == 0) {
        this.crossOverForm.winningAmount = "";
      } else {
        this.crossOverForm.winningAmounts.winningAmount1 = "";
        this.crossOverForm.winningAmounts.winningAmount2 = "";
      }
    },
    // 名单信息btn
    handleListInfo(row) {
      const { activity_id } = row;
      this.$router.push({
        path: "/Crmactivemanage/crossoverActivitiesList",
        query: {
          activity_id: activity_id,
        },
      });
    },
    // 结束活动btn
    handleEndActivity(row) {
      (() => {})(row);
      const { activity_id, activity_name } = row;
      this.activity_id = activity_id;
      this.activity_name = activity_name;
      this.dialogVisibleEnd = true;
    },
    // 编辑btn
    handleEdit(row) {
      console.warn(row);
      const {
        activity_id,
        activity_name,
        frommedia_id,
        channel_id,
        activity_contract,
        business_mobile,
        activity_amount,
        activity_amounttype,
        activity_amounttypename,
        activity_startdate,
        activity_enddate,
        activity_amountrange,
        frommedia_name,
        channel_name,
        activity_rule,
      } = row;
      this.activity_id = activity_id;
      this.activity_name = activity_name;
      this.dialogTitles = "edit";
      this.showSliderBoxCreate = true;
      this.crossOverForm.activity_name = activity_name;
      // this.crossOverForm.frommedia_id = frommedia_id;
      this.crossOverForm.frommedia_name = frommedia_name;
      this.crossOverForm.channel_id = channel_id;
      this.crossOverForm.activity_contract = activity_contract;
      this.crossOverForm.business_mobile = business_mobile;
      this.crossOverForm.winningAmount = activity_amountrange;
      this.crossOverForm.activity_amount = activity_amount;
      this.crossOverForm.activity_rule = activity_rule;
      this.crossOverForm.activity_amounttype = activity_amounttype;
      this.crossOverForm.activity_startdate = [
        activity_startdate,
        activity_enddate,
      ];
      this.crossOverForm.activity_amountrange = activity_amountrange;
      // this.crossOverForm.winningAmounts = activity_amountrange;
      this.crossOverForm.winningAmounts.winningAmount1 = activity_amountrange.split(
        "-"
      )[0];
      this.crossOverForm.winningAmounts.winningAmount2 = activity_amountrange.split(
        "-"
      )[1];
      if (activity_amount === "--") {
        this.crossOverForm.activity_is_amount = "0";
        this.changeVal = "0";
        this.changeVal2 = activity_amounttype;
      } else {
        this.crossOverForm.activity_is_amount = "1";
        this.changeVal = "1";
        this.changeVal2 = activity_amounttype;
      }
    },
    // 删除btn
    handleDelete(row) {
      (() => {})(row);
      const { activity_id, activity_name } = row;
      this.activity_id = activity_id;
      this.activity_name = activity_name;
      this.dialogVisibleDel = true;
    },

    handleColumnChange(k, v, column) {
      (() => {})(k, v, column);
    },
    onSubmit(ruleFrom) {
      this.$refs[ruleFrom].validate((valid) => {
        if (valid) {
          if (this.dialogTitles == "add") {
            this.addActivityAction();
          } else {
            this.editActivityAction();
          }
          this.showSliderBoxCreate = false;
        } else {
          return false;
        }
      });
    },
    timesChange(val) {
      console.warn(val);
      // (() => {})(this.crossOverForm.activityTime);
    },
    handleAdd() {
      (this.changeVal = ""), (this.crossOverForm.activity_name = "");
      // this.crossOverForm.frommedia_id = '';
      this.crossOverForm.frommedia_name = "";
      this.crossOverForm.channel_id = "";
      this.crossOverForm.activity_contract = "";
      this.crossOverForm.business_mobile = "";
      this.crossOverForm.winningAmount = "";
      this.crossOverForm.activity_amount = "";
      this.crossOverForm.activity_rule = "";
      this.crossOverForm.activity_amounttype = "";
      this.crossOverForm.activity_startdate = [];
      this.crossOverForm.activity_is_amount = "";
      this.crossOverForm.winningAmounts.winningAmount1 = "";
      this.crossOverForm.winningAmounts.winningAmount2 = "";
      this.dialogTitles = "add";
      this.showSliderBoxCreate = true;
    },
    hideSliderBox() {
      this.showSliderBoxCreate = false;
    },
    handleConfirm() {
      this.closeActivityAction();
      this.dialogVisibleEnd = false;
      this.customModelVisible = true;
      this.customModelVisible2 = true;
      setTimeout(() => {
        this.customModelVisible = false;
        this.customModelVisible2 = false;
      }, 3000);
    },
    // 删除
    handleConfirmDel() {
      this.deleteActivityAction();
      this.dialogVisibleDel = false;
    },
    // 跨界活动->CRM-活动列表
    activityList() {
      this.selectForms.rangeTime;
      CrmActiveManage.activityList({
        school_id: this.school_id,
        // frommedia_id: this.selectForms.frommedia_id,
        frommedia_name: this.selectForms.frommedia_name,
        channel_id: this.selectForms.channel_id,
        activity_startdate: this.selectForms.rangeTime
          ? this.selectForms.rangeTime[0]
          : "",
        activity_enddate: this.selectForms.rangeTime
          ? this.selectForms.rangeTime[1]
          : "",
        activity_amounttype: this.selectForms.activity_amounttype,
        activity_is_amount: this.selectForms.activity_is_amount,
        keyword: this.selectForms.keyword,
        p: this.currentPage,
        num: this.pagesize,
        is_count: "1", // 是否需要总数
      }).then((res) => {
        console.warn(res);
        const { code, msg, data: body } = res.data;
        const r = body;
        this.tableDatas.columns = r.field;
        this.dataNumber = r.data.allnum;
        if (code === 200) {
          this.dataNumber = r.data.allnum;
          this.tableDatas.list = r.data.datalist;
        } else {
          // this.$message(errortip);
          this.tableDatas.list = [];
          this.tableDatas.options.errortip = msg;
        }
      });
    },
    // CRM-结束活动
    closeActivityAction() {
      CrmActiveManage.closeActivityAction({
        activity_id: this.activity_id,
      }).then((res) => {
        (() => {})(res);
        const { code, msg, data } = res.data;
        if (code === 200) {
          this.activityList();
        } else {
          this.$message.error(msg);
        }
      });
    },

    // CRM-删除未开始活动
    deleteActivityAction() {
      CrmActiveManage.deleteActivityAction({
        activity_id: this.activity_id,
      }).then((res) => {
        (() => {})(res);
        const { code, msg, data } = res.data;
        if (code === 200) {
          this.$message({
            type: "success",
            message: msg,
          });
          this.activityList();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      });
    },

    // CRM-编辑未开始活动
    editActivityAction() {
      CrmActiveManage.editActivityAction({
        activity_id: this.activity_id,
        activity_name: this.crossOverForm.activity_name,
        // frommedia_id: this.crossOverForm.frommedia_id,
        frommedia_name: this.crossOverForm.frommedia_name,
        channel_id: this.crossOverForm.channel_id,
        activity_contract: this.crossOverForm.activity_contract,
        business_mobile: this.crossOverForm.business_mobile,
        activity_amount: this.crossOverForm.activity_amount,
        activity_amount: this.crossOverForm.activity_amount,
        activity_amounttype: this.crossOverForm.activity_amounttype,
        activity_startdate: this.crossOverForm.activity_startdate[0],
        activity_enddate: this.crossOverForm.activity_startdate[1],
        activity_amountrange:
          this.changeVal2 == 1
            ? `${parseFloat(this.crossOverForm.winningAmounts.winningAmount1) +
                "," +
                parseFloat(this.crossOverForm.winningAmounts.winningAmount2)}`
            : `${parseFloat(this.crossOverForm.winningAmount) +
                "," +
                parseFloat(this.crossOverForm.winningAmount)}`,
        activity_rule: this.crossOverForm.activity_rule,
      }).then((res) => {
        (() => {})(res);
        const { code, msg, data } = res.data;
        if (code === 200) {
          this.activityList();
          this.$message({
            type: "success",
            message: msg,
          });
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      });
    },

    // CRM-添加跨界活动
    addActivityAction() {
      CrmActiveManage.addActivityAction({
        activity_name: this.crossOverForm.activity_name,
        // frommedia_id: this.crossOverForm.frommedia_id,
        frommedia_name: this.crossOverForm.frommedia_name,
        channel_id: this.crossOverForm.channel_id,
        activity_contract: this.crossOverForm.activity_contract,
        business_mobile: this.crossOverForm.business_mobile,
        activity_amount: this.crossOverForm.activity_amount,
        activity_amount: this.crossOverForm.activity_amount,
        activity_amounttype: this.crossOverForm.activity_amounttype,
        activity_startdate: this.crossOverForm.activity_startdate[0],
        activity_enddate: this.crossOverForm.activity_startdate[1],
        activity_amountrange:
          this.changeVal2 == 1
            ? `${parseFloat(this.crossOverForm.winningAmounts.winningAmount1) +
                "," +
                parseFloat(this.crossOverForm.winningAmounts.winningAmount2)}`
            : `${parseFloat(this.crossOverForm.winningAmount) +
                "," +
                parseFloat(this.crossOverForm.winningAmount)}`,
        activity_rule: this.crossOverForm.activity_rule,
      }).then((res) => {
        (() => {})(res);
        const { code, msg, data } = res.data;
        if (code === 200) {
          this.$message({
            type: "success",
            message: msg,
          });
          this.activityList();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      });
    },

    // 获取渠道类型
    getSourceTwoApi() {
      this.$http.getSourceTwoApi({}).then((res) => {
        this.SourceList = res.data.data.list;
      });
    },
    // 获取渠道明细
    getChannelTwoApi() {
      this.$http
        .getChannelTwoApi({
          channel_medianame:
            this.selectForms.frommedia_name ||
            this.crossOverForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.tableDatas.list = [];
      this.activityList();
    },
    // 招生渠道类型筛选
    // frommediaSearch() {
    //   this.currentPage = 1;
    //   this.selectForm.channel_id = "";
    //   this.getChannelTwoApi(); // 获取渠道明细
    //   this.getSellgoalData(this.pagenum);
    // },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.tableDatas.list = [];
      this.activityList();
    },

    // 关闭活动模板预览图
    // handleClosePreview() {
    //   this.PreviewVisible = false;
    // },
    hideSliderBoxCreate() {
      this.showSliderBoxCreate = false;
    },
    // hideSliderBoxEdit() {
    //   this.showSliderBoxEdit = false;
    // },
    // hideSliderBoxSee() {
    //   this.showSliderBoxSee = false;
    // },
    // handleDel() {
    //   this.dialogVisible = true;
    // },

    // changeSize() {
    //   (() => {})("change");
    // },
    // handleSliderClick(tab, event) {
    //   (() => {})(tab, event);
    // },
    // handleSliderSeeClick(tab, event) {
    //   (() => {})(tab, event);
    // },
    // handleClick(v) {
    //   this.showSliderBoxSee = true;
    //   (() => {})(v);
    //   this.activityId = v.activity_id;
    //   this.activeOne = v;
    //   this.getgoalActivityOneData(v.activity_id);
    // },
    // handleCreateClick() {
    //   this.showSliderBoxCreate = true;
    // },
    handleClose(done) {
      this.$confirm(this.$t("Crmactivemanage.bo"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },

    handleCloseCode(done) {
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.activityList();
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.activityList();
    },

    //点击查看二维码
    handleCodeChange(k, v, col) {
      console.warn(k, v, col);
      if (col.fieldstring == "activity_qrcode") {
        // this.onCodeInfo.oneCodeImg = v.activity_qrcode; // 活动二维码
        this.onCodeInfo.oneCodeWxImg = v.activityQRcodeUrl; // 活动二维码
      } else {
        // this.onCodeInfo.oneCodeImg = v.business_qrcode; // 商家二维码
        this.onCodeInfo.oneCodeWxImg = v.businessQRcodeUrl;
      }
      // if (col.isschool == "1") {
      //   this.onCodeInfo.oneCodeImg = v.qrcode; //学校二维码
      //   this.onCodeInfo.oneCodeWxImg = v.QRcodeUrl; //学校二维码
      //   this.onCodeInfo.oneCodeUrl = v.qrcodeurl;
      // } else {
      //   this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
      //   this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
      //   this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
      // }
      this.dialogVisible = true;
    },

    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      // for (name in this.selectForms) {
      //   if (name != "rang_time") {
      //     // 时间范围不需要
      //     params_str = params_str + `&${name}=${this.selectForms[name]}`;
      //   }
      // }
      for (name in this.selectForms) {
        if (name != "amounttypeOptions" && name != "is_amountOptions") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForms[name]}`;
        }
      }
      let url = CrmActiveManage.activityList1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableDatas.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableDatas.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");

.activitiesManage {
  height: 100vh;
  font-size: 20px;
  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      img {
        width: 165px !important;
        height: 165px;
      }
    }
    .left {
      margin-right: 10px;
      .one-img {
        width: 220px;
        height: 220px;
        padding-top: 13px;
      }
      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }
    .right {
      margin-left: 10px;
    }
    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }

  .customModel {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    z-index: 2016 !important;
  }
  .customFather {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 2017 !important;
    .customChild {
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: inline-block;
      width: 420px;
      height: 180px;
      padding-bottom: 10px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      font-size: 18px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      text-align: left;
      overflow: hidden;
      backface-visibility: hidden;
      .customInfo {
        display: block;
        text-align: center;
        line-height: 180px;
      }
    }
  }

  .tip-text {
    display: inline-block;
    margin: 0 13px;
    color: #d0021b;
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 10px;
      background: rgba(210, 11, 36, 1);
      border-radius: 50%;
      font-style: normal;
      color: #fff;
      text-align: center;
      line-height: 20px;
    }
  }
}
.delete-tips {
  padding: 45px 0;
  font-size: 14px;
  text-align: center;
  color: #333;
}
</style>
